import * as React from 'react';
import { FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import { Translate } from '../../../../../shared/LanguageService';
import { IRecipient } from '../Types';
import FormSelect from '../../../../../components/common/FormSelect';

interface IProps {
    onChange: (e: any) => void;
    recipients: IRecipient[];
    recipient: number;
    errors: any;
}

const RecipientSelect = (props: IProps) => {
    function errorExists(errors: any, key: string) {
        if (errors && errors[key]) {
            return true;
        }

        return false;
    }

    return (
        <FormGroup validationState={errorExists(props.errors, 'recipient') ? 'error' : null}>
            <ControlLabel>
                {Translate('view-order/basic-order/modal/create-email/form/to')}
            </ControlLabel>
            <FormSelect
                name="recipient"
                value={props.recipient as any}
                onChange={props.onChange}
                defaultTranslateKey="view-order/basic-order/modal/create-email/form/to/placeholder"
            >
                {props.recipients &&
                    props.recipients.map((r: IRecipient, index: number) => {
                        return (
                            <option key={index + 1} value={(index + 1) as any}>
                                {r.contactInfo}
                            </option>
                        );
                    })}
            </FormSelect>
            {props.errors && <HelpBlock>{props.errors.recipient}</HelpBlock>}
        </FormGroup>
    );
};

export default RecipientSelect;
